import { IconLoginLogo } from "@/assets/icons/IconLoginLogo";
import { RegisterForm } from "@/features/auth/components/RegisterForm";
import { verifyResetTokenApi } from "@/features/auth/services/verify-reset-token-api";
import { TRegisterQueryParam } from "@/features/auth/types/registerQueryParam";
import { AppRoutes } from "@/routes/config";
import { black, text } from "@/theme/colors";
import { getQueryFromURL } from "@/utils/url";
import { CircularProgress, Paper, Stack, Typography, styled } from "@mui/material";
import { FC, useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export const RegisterPage: FC = () => {
  const query = getQueryFromURL<TRegisterQueryParam>();
  const navigate = useNavigate();
  const [isVerifying, setIsVerifying] = useState(true);
  const [isTokenValid, setIsTokenValid] = useState(false);

  const verifyToken = useCallback(async () => {
    if (!query?.email || !query?.resetToken) {
      navigate(AppRoutes.pageNotFound, { replace: true });
      return;
    }

    try {
      await verifyResetTokenApi({ email: query.email, resetToken: query.resetToken });
      setIsTokenValid(true);
    } catch (error) {
      navigate(AppRoutes.pageNotFound, { replace: true });
    } finally {
      setIsVerifying(false);
    }
  }, [query?.email, query?.resetToken, navigate]);

  useEffect(() => {
    verifyToken();
  }, [verifyToken]);

  return (
    <Stack gap="80px" alignItems="center" width="100%">
      <Stack gap={1}>
        <IconLoginLogo />
        <Stack alignItems="center" width={240} paddingY={1} bgcolor={black[30]}>
          <Typography variant="sub16Bold" color="white">
            center│システム管理
          </Typography>
        </Stack>
      </Stack>
      <Container elevation={0}>
        {isVerifying && (
          <Stack alignItems="center" justifyContent="center" py={4}>
            <CircularProgress />
          </Stack>
        )}
        {!isVerifying && isTokenValid && (
          <Stack gap={4} alignItems="center">
            <Typography variant="head20Bold" color={text.primary}>
              新規管理ユーザー登録
            </Typography>
            <RegisterForm />
          </Stack>
        )}
      </Container>
    </Stack>
  );
};

const Container = styled(Paper)`
  width: 464px;
  padding: 32px;
  border-radius: 12px;
  box-shadow:
    0 4px 4px -1px rgba(12, 12, 13, 0.05),
    0 4px 4px -1px rgba(12, 12, 13, 0.1) !important;
`;
